/**
 * Forward start premium type.
 * tag: 41160
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentForwardStartType {
  /** Prepaid */
  Prepaid = 0,
  /** Post-paid */
  Postpaid = 1,
  /** Variable */
  Variable = 2,
  /** Fixed */
  Fixed = 3,
}
